BookingApp.service('HotelServices',['$http','$filter','$q','$location',function($http,$filter,$q,$location){
    var request,MinPrice = 0,MaxPrice = 0;
    //var hotels = { buses:[],status:'Not-Set' };


    this.setRequest = function(Rdata){
        //console.log(Rdata);
        var row = JSON.parse(Rdata.Request)
        request = row;
        request.CityCode = Rdata.CityCode
    }

    this.getRequest = function(){
        return request;
    }

    this.getData = function(data){
        //console.log("Log from HotelServices");
        var delay = $q.defer();
        //console.log(data);

        $http({
            method: 'POST',
            url: '/hotels/search',
            data:data,
            headers:{'X-Requested-With':'XMLHttpRequest'},
        }).then(function successCallback(response) {
            // this callback will be called asynchronously
            // when the response is available
            delay.resolve( response.data );
        }, function errorCallback(response) {
            // called asynchronously if an error occurs
            // or server returns response with an error status.
            delay.resolve( response.data );
        });

        return delay.promise;
    }

    this.setMinMaxPrice = function (hotels) {
        angular.forEach(hotels,function (hotel) {
            //Set MinPrice
            if(parseInt(hotel.Price.RoomPrice) > MaxPrice){
                MaxPrice = parseInt(hotel.Price.RoomPrice);
            }

            //Set MaxPrice
            if(parseInt(hotel.Price.RoomPrice) < MinPrice){
                MinPrice = parseInt(hotel.Price.RoomPrice);
            }
        })
    }

    this.getHotelInfo = function(trace,HotelCode,index){
        var delay = $q.defer();

        $http({
            method: 'POST',
            url: '/hotels/hotel-info',
            data:{trace:trace,hotelCode:HotelCode,index:index},
            headers:{'X-Requested-With':'XMLHttpRequest'},
        }).then(function successCallback(response) {
            console.log(response.data);
            delay.resolve(response.data);
        },function errorCallback(response){
            console.log(response.data);
            delay.resolve(response.data);
        })
        return delay.promise;
    }

    this.getPrice 				= function(type){	return (type == 'min') ? MinPrice : MaxPrice;	}

}]);
